import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { fmt } from '../helpers/helpers';
import { resolveEntryLabel } from '../helpers/metadataHelpers';
import store from '../stores/NotesStore';
import HistoryModal from './HistoryModal';
import MetadataLinkModal from './MetadataLinkModal';
import PaymentSourceModal from './PaymentSourceModal';

const IncomeTable = observer(() => {
  const [historyModalEntryId, setHistoryModalEntryId] = useState(null);
  const [metadataLinkId, setMetadataLinkId] = useState(null);
  const [sourceModalEntry, setSourceModalEntry] = useState(null);

  const positives = store.positives;

  if (positives.length === 0) return null;

  const showUsedForCol = !store.isGuest;

  return (
    <>
      <table className="neg-table income-table">
        <thead>
          <tr>
            <th>Descrição</th>
            <th>Cadastro</th>
            {showUsedForCol && <th>Usado para pagar</th>}
            <th>Info</th>
            <th style={{ textAlign: 'right' }}>Valor</th>
          </tr>
        </thead>
        <tbody>
          {positives.map(row => {
            const hasHistory = row.history && row.history.length > 1;
            const sources = showUsedForCol ? store.sourcesForIncome(row.id) : [];

            return (
              <tr key={row.id}>
                <td>{resolveEntryLabel(row, store)}</td>
                <td className="metadata-link-cell">
                  <button
                    className={`metadata-link-btn ${row.metadataId ? 'has-metadata' : ''}`}
                    onClick={() => setMetadataLinkId(row.id)}
                    title={row.metadataId ? `Vinculado: ${resolveEntryLabel(row, store)}` : 'Vincular a cadastro'}
                  >
                    {row.metadataId ? (
                      <i className="fas fa-link"></i>
                    ) : (
                      <i className="fas fa-link" style={{ opacity: 0.3 }}></i>
                    )}
                  </button>
                </td>
                {showUsedForCol && (
                  <td
                    className="metadata-link-cell"
                    style={{ cursor: 'pointer' }}
                    title={sources.map(s => `${s.expense.label} (${fmt(s.amount)})`).join(', ')}
                    onClick={() => setSourceModalEntry(row)}
                  >
                    {sources.length === 0 ? (
                      <span style={{ color: '#ddd' }}>—</span>
                    ) : (
                      <>
                        {sources.slice(0, 2).map(s => `${s.expense.label} (${fmt(s.amount)})`).join(', ')}
                        {sources.length > 2 && ` +${sources.length - 2}`}
                      </>
                    )}
                  </td>
                )}
                <td className="info-cell">
                  {hasHistory ? (
                    <button
                      className="info-btn"
                      onClick={() => setHistoryModalEntryId(row.id)}
                      title="Ver histórico de alterações"
                    >
                      <i className="fas fa-info-circle"></i>
                    </button>
                  ) : (
                    <span style={{ color: '#ddd' }}>—</span>
                  )}
                </td>
                <td style={{ textAlign: 'right' }}>{fmt(row.value)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {historyModalEntryId && (
        <HistoryModal
          entryId={historyModalEntryId}
          entry={positives.find(e => e.id === historyModalEntryId)}
          onClose={() => setHistoryModalEntryId(null)}
        />
      )}

      {metadataLinkId && (
        <MetadataLinkModal
          entry={positives.find(e => e.id === metadataLinkId)}
          onClose={() => setMetadataLinkId(null)}
        />
      )}

      {sourceModalEntry && (
        <PaymentSourceModal
          entry={sourceModalEntry}
          mode="income"
          onClose={() => setSourceModalEntry(null)}
        />
      )}
    </>
  );
});

export default IncomeTable;
